module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lB9ew"))).then(() => parcelRequire('5erN3'));